module.exports = __webpack_public_path__ + "img/stage3.82c9dbf3.png";